import React, { useState, useEffect, useRef } from 'react';
import { Box, IconButton, Button, Typography, Modal, Stack } from "@mui/material";

import { Notifications } from '@mui/icons-material';
import useAxiosPrivate from "../utils/useAxiosPrivate";
import { useAuth } from "../utils/AuthProvider";
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import i18n from '../translationUtils/i18n';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  overflow: 'scroll',
  overflowX: "hidden",
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const Dropdown = ({ notifications, onSelect }) => {

  const convertTime = (timeString) => {
    if (timeString) {
      const time = moment(timeString, 'HH:mm:ss');
      return time.format('h:mm A');
    } else {
      return null
    }
  };

  return (
    <Box>
      {notifications ? (
        notifications.slice(0, 5).map((notification) => (
          <Stack key={notification.eventNotificationId} onClick={() => onSelect(notification)} paddingBottom={0.5} sx={{ cursor: 'pointer' }}>
            <Stack 
            borderRadius={3}
            border={0.5}
            padding={1}
            >
              {notification.isTest ? <Typography>{i18n.t('testalert')} - {notification.eventType}</Typography> : <Typography>{i18n.t('fireroveractivated')}: {notification.eventType}</Typography>}
              <Typography fontSize={14}>{i18n.t('unit')}: {notification.productName}</Typography>
              <Typography fontSize={14}>{i18n.t('site')}: {notification.siteName}</Typography>
              <Typography fontSize={14}>{i18n.t('systemtime')}: {notification.dateOfEvent}, {convertTime(notification.systemLocalTime)}</Typography>
              <Typography fontSize={14}>{i18n.t('localtime')}: {notification.dateOfEvent}, {convertTime(notification.systemLocalTime)}</Typography>
            </Stack>
          </Stack>
        ))
      ) : (
        <Typography>{i18n.t('nonotifications')}</Typography>
      )}
    </Box>
  );
};

const NotificationsButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const buttonRef = useRef(null);
  const [buttonY, setButtonY] = useState(null);
  const [buttonX, setButtonX] = useState(null);
  const [buttonHeight, setButtonHeight] = useState(null);
  const [openedNotification, setOpenedNotification] = useState(null);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const servicePhone = "248-200-3730"

  const navigate = useNavigate();
  const { cookies } = useAuth();
  const axiosPrivate = useAxiosPrivate();
  const [eventNotificationRows, setEventNotificationRows] = useState([]);

  const handleOpenModal = () => {
    fetchData();
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOpenNotification = () => {
    setIsNotificationOpen(true);
  };

  const handleCloseNotification = () => {
    setIsNotificationOpen(false);
  }

  const handleNotificationSelect = (value) => {
    setOpenedNotification(value);
    handleOpenNotification();
  };

  const handleShowMore = () => {
    setIsModalOpen(false);
    navigate(`/notifications`)
  }

  const fetchData = () => {
    const controller = new AbortController();

    const getEventNotifications = async () => {
      try {
        if (cookies.user) {
          const response = await axiosPrivate.get('/api/User/eventNotifications/' + cookies.user, {
            signal: controller.signal
          })
  
          setEventNotificationRows(response.data.slice().reverse());
        }
      } catch (err) {
        console.log(err);
      }
    }

    getEventNotifications();

    return () => {
      controller.abort();
    }
  }

  useEffect(() => {
    if (buttonRef.current) {
      setButtonX(buttonRef.current.getBoundingClientRect().x);
      setButtonY(buttonRef.current.getBoundingClientRect().y);
      setButtonHeight(buttonRef.current.getBoundingClientRect().height);
    }
    // eslint-disable-next-line 
  }, [buttonRef]);

  const convertTime = (timeString) => {
    const time = moment(timeString, 'HH:mm:ss'); // Parse the time string
    return time.format('h:mm A');
  };

  return (
    <>
      <IconButton ref={buttonRef} onClick={handleOpenModal} sx={{ color: 'white' }}>
        <Notifications />
      </IconButton>
      <Modal 
        open={isModalOpen} 
        onClose={handleCloseModal}
      >
        <Box
          sx={{
            position: "relative",
            top: buttonY + buttonHeight,
            left: buttonX - 7*buttonHeight,
            maxHeight: "80%",
            width: "20%",
            overflowX: "hidden",
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 1,
            borderRadius: 3,
          }}
        >
          {eventNotificationRows ? 
            <>
              <Dropdown notifications={eventNotificationRows} onSelect={handleNotificationSelect} />
              <Stack sx={{alignItems: "center", padding: 1}}>
                <Button variant="contained" onClick={handleShowMore}>
                  {i18n.t('showmore')}
                </Button>
              </Stack>
            </>
          : 
            <Stack sx={{alignItems: "center"}}>
              <Typography>{i18n.t('nonotifications')}</Typography>
            </Stack>
          }
        </Box>
      </Modal>
      <Modal 
        open={isNotificationOpen} 
        onClose={handleCloseNotification}
      >
        <Box
          sx={style}
        >
          <Box style={{
            padding: "1%", 
            backgroundColor: 'rgba(59, 59, 59, 0.15)', 
            alignItems: "center",
            display: 'flex',
            gap: "4%"
          }}>
            <Box>
              {openedNotification?.fileLink ?
                <img
                  src={openedNotification ? openedNotification?.fileLink : null}
                  alt={''}
                  width={"100%"}
                />
              :
                <Typography fontWeight={"bold"} noWrap>{i18n.t('noimage')}</Typography>
              }
            </Box>
            <Box>
              <Typography noWrap>{i18n.t('unit')}: {openedNotification ? openedNotification.productName : null}</Typography>
              <Typography noWrap>{i18n.t('site')}: {openedNotification ? openedNotification.siteName : null}</Typography>
              <Typography noWrap>{i18n.t('systemtime')}: {openedNotification ? openedNotification.dateOfEvent : null}, {convertTime(openedNotification ? openedNotification.systemLocalTime : null)}</Typography>
              <Typography noWrap>{i18n.t('localtime')}: {openedNotification ? openedNotification.dateOfEvent : null}, {convertTime(openedNotification ? openedNotification.systemLocalTime : null)}</Typography>
            
              <Typography noWrap>{i18n.t('accountmanager')}: {openedNotification ? openedNotification.accountManager : null}</Typography>
              <Typography noWrap>{i18n.t('accountmanagerphone')}: {openedNotification ? openedNotification.accountManagerPhone : null}</Typography>
              <Typography noWrap>{i18n.t('centralstationphone')}: {openedNotification ? openedNotification.centralStationPhone : null}</Typography>
              <Typography noWrap>{i18n.t('servicedepartmentphone')}: {servicePhone}</Typography>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default NotificationsButton;